import {Component, Input} from '@angular/core';
import {RelatedContent} from '@shared/services/hygraph/hygraph.models';

@Component({
    selector: 'app-hygraph-related-content',
    templateUrl: './related-content.component.html',
    styleUrls: ['./related-content.component.scss'],
    standalone: false
})
export class HygraphRelatedContentComponent {
  @Input() relatedContentItems: RelatedContent[];

  constructor() {}

  public navigateTo(content: RelatedContent) {
    window.open(content.contentLink, '_blank');
  }
}
